export const initialFilters = { offset: 0, limit: 50 }

export const initialParams = {
  search: '',
  country_id: [],
  lead_agency_id: [],
  cluster_id: [],
  project_type_id: [],
  sector_id: [],
  category: [],
  status_id: [],
  pcr_status: [],
  pcr_due: [],
  ad_hoc_pcr: [],
  pcr_submission_date_after: '',
  pcr_submission_date_before: '',
}
export const pcrFieldsMapping: { [key: string]: string } = {
  region: 'Region',
  country: 'Country',
  lead_agency: 'Lead agency',
  cooperating_agency: 'Cooperating agency',
  cluster: 'Cluster',
  project_type: 'Type',
  sector: 'Sector',
  subsectors: 'Subsector',
  category: 'Category',
  pcr_due: 'PCR due',
  ad_hoc_pcr: 'Ad-hoc PCR',
  pcr_submission_date: 'PCR submission date',
  completed_only: 'Completed',
  title: 'Title',
  metacode: 'Metacode',
  status: 'Status',
  pcr_status: 'PCR status',
  code: 'Code',
  tranche: 'Tranche',
  agency: 'Agency',
  total_fund: 'Project funding',
  support_cost_psc: 'Project support costs',
  decisions: 'Relevant decision(s)',
  project_date_approved: 'Date of approval of the project',
  project_date_completion: 'Date of completion of the project',
  phase_out_ods_actual: 'ODP phase-out (Actual)',
  phase_out_ods_approved: 'ODP phase-out (Approved)',
  phase_out_co2_eq_t_actual: 'HFCs phased down (CO2 eq-tonnes) (Actual)',
  phase_out_co2_eq_t_approved: 'HFCs phased down (CO2 eq-tonnes) (Approved)',
  total_number_of_enterprises: 'Number of enterprises',
  total_number_of_trainnes: 'Total number of trainees',
  mlf_funding_approved: 'MLF funding approved',
  mlf_funding_disbursed: 'MLF funding disbursed',
  mlf_funding_returned: 'MLF funding returned',
  total_mlf_funding_approved: 'Total MLF funding approved',
  total_mlf_funding_disbursed: 'Total MLF funding disbursed',
  total_mlf_funding_returned: 'Total MLF funding returned',
  financial_figures_status: 'Financial figures status',
  financial_figures_status_explanation:
    'Financial figures - explanations, if needed',
  addresses: 'Address(es) of enterprise(s) and project site(s), if applicable',
  project_goal_achieved: 'All project goals achieved',
  project_goal_achieved_explanation:
    'If no, please provide a brief explanation',
  rating: 'Overall rating',
  rating_explanation_other: 'Specify rating',
  rating_explanation: 'Please explain your rating',
  entity: 'Entity user inputting the comment on behalf',
  comment: 'Comment',
  completed_by: 'Completion report done by',
  funds_disbursed: 'Funds disbursed',
  planned_date_of_completion: 'Planned date of completion',
  substance_from: 'Substance converted from',
  substance_to: 'Substance converted to',
  address: 'Address of enterprise',
  disposal_type: 'Disposal type',
  disposal_date: 'Date of disposal',
  activity_title: 'Activity title',
  planned_output: 'Planned output(s)',
  actual_activity_output: 'Actual output(s)',
  additional_remarks: 'Additional remarks, if applicable',
  delay_cluster_id: 'Delay cluster',
  delay_id: 'Cause of delay',
  description: 'Description',
  description_roots_causes_of_delay: 'Description',
  action_taken: 'Action taken',
  lesson_id: 'Lesson learned',
  project_preparation: 'Project cycle phase',
  qualitative_description: 'Qualitative description',
  prefilled: 'Gender policy implemented',
  sdg_applying:
    'Did the project contribute to any Sustainable Development Goals (SDGs)?',
  sdg_not_applying_explanation: 'Explanation',
  goal_id: 'SDG',
  section_id: 'Section',
}

export const viewPcrFieldsMapping: { [key: string]: string } = {
  total_mlf_funding_approved: 'MLF funding approved',
  total_mlf_funding_disbursed: 'MLF funding disbursed',
  total_mlf_funding_returned: 'MLF funding returned',
}

export const pcrFieldsErrorsMapping: { [key: string]: string } = {
  financial_figures_status_explanation: 'Financial figures - explanations',
  addresses: 'Address(es) of enterprise(s) and project site(s)',
  project_goal_achieved_explanation: 'All project goals achieved explanation',
  rating_explanation: 'Rating explanation',
  additional_comments: 'Additional comment',
  comment: 'Comment',
  alternative_technologies: 'Alternative technology',
  enterprises: 'Enterprise',
  equipments: 'Equipment',
  overall_assessment_highlights: 'Activity',
  project_components: 'Project component',
  delay_causes: 'Cause of delay',
  learned_lessons: 'Lesson learned',
  gender_mainstreamings: 'Gender mainstreaming',
  sustainable_development_goals: 'SDG',
  sdg_applying:
    'Project contributing to any Sustainable Development Goals (SDGs)',
  supporting_evidences: 'Supporting evidence',
}

export const categoryOpts = [
  { id: 'Individual', name: 'IND' },
  { id: 'Multi-year agreement', name: 'MYA' },
]

export const booleanFieldsOpts = [
  { id: 'Yes', name: 'Yes' },
  { id: 'No', name: 'No' },
]

export const extendedBooleanFieldsOpts = [
  ...booleanFieldsOpts,
  { id: 'Not applicable', name: 'N/A' },
]

export const financialFiguresTypeOptions = [
  { id: 'Provisional', name: 'Provisional' },
  { id: 'Final', name: 'Final' },
]

export const disposalTypeOptions = [
  { id: 1, name: 'Disposal type 1', label: 'Disposal type 1' },
  { id: 2, name: 'Disposal type 2', label: 'Disposal type 2' },
  { id: 3, name: 'Disposal type 3', label: 'Disposal type 3' },
]

export const projectPhaseOptions = [
  { id: 'Project preparation', name: 'Project preparation' },
  { id: 'Planning/Formulation', name: 'Planning/Formulation' },
  { id: 'Implementation', name: 'Implementation' },
  { id: 'Monitoring and Reporting', name: 'Monitoring and Reporting' },
]

export const initialOverviewData = {
  financial_figures_status: '',
  financial_figures_status_explanation: '',
  addresses: '',
  project_goal_achieved: '',
  project_goal_achieved_explanation: '',
  rating: '',
  rating_explanation_other: '',
  rating_explanation: '',
  additional_comments: [],
  completed_by: '',
}

export const initialActivitiesData = {
  activity_title: '',
  planned_output: '',
  actual_activity_output: '',
  additional_remarks: '',
}

export const defaultSummaryOfKeyDataErrors = {
  general: {},
  alternative_technologies: {},
  enterprises: {},
  equipments: {},
}

export const requiredMessage = 'This field is required.'

export const summaryOfKeyDataField = 'pcr_projects'
export const delayField = 'delay_causes'
export const cdField = 'causes_of_delay'
export const dcField = 'root_causes_of_delay'
export const llField = 'lessons'
export const ppField = 'gender_mainstreamings'
export const sdgsContributionField = 'sustainable_development_goals'
export const sdgsField = 'goals'
export const sdgAgencyErrorsField = 'sdg_agency_errors'
export const supportingEvidencesField = 'supporting_evidences'
export const evidencesField = 'evidences'

export const borderedValueClassname =
  'rounded border border-solid border-primary px-2 py-1 leading-tight w-fit !font-medium'
export const borderedValueContainerClassname = {
  containerClassname: '!flex-row gap-4 items-center',
  valueClassname: borderedValueClassname,
}

const valueClassname = 'min-w-0 flex-1 !text-black !font-normal !text-lg'
const labelClassname = 'self-start mt-0.5'

const commonClassnames = { labelClassname, valueClassname }

export const overviewTextareaClassname = {
  containerClassname: '!gap-2 lg:!gap-20 lg:!flex-row w-full lg:w-[85%]',
  labelClassname: labelClassname + ' lg:w-[20%]',
  valueClassname: valueClassname,
}

export const pcTitleClassname = {
  containerClassname: 'gap-2',
  labelClassname: 'uppercase text-mlfs-hlYellow text-lg',
  valueClassname: 'text-white !font-medium !text-3xl',
}

export const textareaClassname = {
  containerClassname: 'w-full lg:w-[65%] p-0',
  ...commonClassnames,
}

export const fundingFields = [
  'mlf_funding_approved',
  'mlf_funding_disbursed',
  'mlf_funding_returned',
]

export const borderedContainerClassname = 'border border-solid border-[#e5e7eb]'
